import {message} from "antd";
import {Activiti, actChoose, actText, activiti} from "../activity/public";
import {getActivitiKeyByconf, loadButtonList} from "../../actions/weiChat";
import {saveStatusName} from "../../actions/weiBo";
import $ from "jquery";
export const actInit = (data,that) => {
    let canDo = true;
    Activiti.createActivit({
        id: "#btnArea", //渲染选择器
        class:"funButton",
        uuid:data && data.uuid? data.uuid:"",   //主键id
        pojoName:"weibo",
        againFlag:data && (data.statusName === '草稿' || data.statusName === '撤稿'),
        userAccount: that.currentUser.account,
        activitiConf:[{
            mediaCode: that.state.mediaCode
        }],
        showAfterFuns: {   //按钮加载前置js
            //撤回按钮显示前置js
            callBackBtnShow: function(item, call){
                //不允许编辑
                canDo = false;
                call({"code":1});
            },
            publishCheck : function(item, call){
                if(that.buttonRole.publish == true){
                    call({code:1,log:"拥有发布权限"});
                }else{
                    call({code:0,log:"未拥有发布权限"})
                }
            }
        },
        otherJs: {
            callActRevert : (activiti,buttonConf,call) => {
                activiti.terminate.call(activiti,(res) =>{
                    if(res){
                        activiti.options.statusNameTemp = "草稿";
                        activiti.endFunction(activiti,function(res){
                            if(res.status){
                                activiti.successMsg("流程已撤回，稿件变为草稿状态", function () {
                                    activiti.submitOK.call(activiti);
                                });
                            }
                        })
                    }
                });
            }
        },
        success : (activiti) =>{   //对象创建成功回调
            that.activitiObj = activiti;
            activiti.render = (btns = [],call) =>{
                let buttonList = [];
                if(that.buttonRole && that.buttonRole.edit == true)
                {
                    // 流程按钮
                    btns.map((item, index) =>{
                        let showBtnFlag = false;
                        let args = [];
                        let button = {
                            type: "act",
                            name: item.name
                        };
                        //前置js
                        if(item.document && item.document.lineJavaScript && item.document.lineJavaScript.afterButtonShow && activiti.options.showAfterFuns[item.document.lineJavaScript.afterButtonShow]){
                            let func = eval(activiti.options.showAfterFuns[item.document.lineJavaScript.afterButtonShow]);
                            new func(item,(res)=>{
                                if(res.log){
                                    activiti.log(res.log);
                                }
                                if(res.code >0){
                                    showBtnFlag = true;
                                    console.log("按钮显示" + index);
                                }else if(res.code == 0){
                                    activiti.log("状态：0 ，" +  item + ":" +res.log || res.msg);
                                }else{
                                    activiti.error(item + ":" + res.log)
                                }
                            });
                        }else{
                            showBtnFlag = true;
                        }
                        if(item.document.lineJavaScript.otherJs && item.document.lineJavaScript.otherJs.split(",").length > 0){
                            let funArray = item.document.lineJavaScript.otherJs.split(",");
                            funArray.map((item, index)=>{
                                let funtemp = function(){
                                    let callback = Activiti.util.getCallbackFn.call(funtemp);
                                    let func = activiti.options.otherJs[funArray[index]];
                                    if(func){
                                        func.call(activiti,activiti,item,function(res){
                                           /* if(res){
                                                callback.call(that,item);
                                            }else{
                                                activiti.error(res || "执行出错！");
                                            }*/

                                            if(res.log){
                                                activiti.log(res.log);
                                            }
                                            if(res.code >0){
                                                callback.call(that,item);
                                                console.log("按钮显示" + index);
                                            }else if(res.code == 0){
                                                activiti.log("状态：0 ，" +  item + ":" +res.log || res.msg);
                                            }else{
                                                activiti.error(item + ":" + res.log)
                                            }

                                        })
                                    }else{
                                        activiti.error("未找到前置js：" + funArray[index] + ",请清除浏览器缓存重试。如清理缓存后问题依然存在，请联系管理员。")
                                    }
                                };
                                args.push(funtemp);
                            });
                        }
                        if(showBtnFlag){
                            args.push(() =>{
                                activiti.buttonClick.call(activiti,item)
                            });
                            button.functions = args;
                            buttonList.push(button);
                        }
                    });
                }

                // 其他按钮
                if( (
                    data && (data.statusName === '发布失败'||data.statusName === '撤稿' || data.statusName === '定时发布') && (that.buttonRole && that.buttonRole.publish == true))
                ){
                    buttonList.push({
                        name : "发布",
                        type : "publish"
                    });
                }

                if((buttonList.length > 0 && canDo) ||
                    //我的撤稿
                    (data && (data.statusName === '撤稿') && that.currentUser.account === data.submitter) ||

                    //定时发布具有发布权限的
                    (data && (data.statusName === '定时发布') && (that.buttonRole && that.buttonRole.publish == true))

                ){
                    buttonList.push({
                        name : "保存",
                        type : "save"
                    })
                }


                if(data && data.statusName === '发布'){
                    buttonList.push({
                        name : "访问",
                        type : "view"
                    });
                    if(that.buttonRole && that.buttonRole.revert == true)
                    {
                        buttonList.push({
                            name : "撤稿",
                            type : "revert"
                        });
                    }
                }
                if(data && that.buttonRole.delete &&
                    (
                        (data.statusName === "弃用" || data.statusName === "撤稿") ||
                        //我的定时发布
                        (data.statusName === "定时发布")
                    )
                ){
                    {
                        buttonList.push({
                            name : "删除",
                            type : "delete"
                        });
                    }
                }

                that.setState({btns: buttonList});
                call()
            };
            activiti.getActivitiKey = (activitiConf, call) => {
                getActivitiKeyByconf(activitiConf,(res) =>{
                    if(res && res.activitiApp && res.activitiApp.key){
                        call(res.activitiApp.key);
                    }else{
                        call(false);
                    }
                });
            };
            activiti.loadButtonList = (call) =>{
                loadButtonList({
                    processInstanceId : activiti.activitiData.processInstanceId || "",
                    deploymentKey : activiti.activitiData.deploymentKey || ""
                },(data)=>{
                    if(data && data.length > 0 ){
                        activiti.render(data,call);
                    }else{
                        activiti.render([],call);
                    }
                });
            };
            actChoose.getChoose = (data,type,callback) =>{
                that.refs.chooseUserModal.showModal(data,(accountArray) =>{
                    let callbackValue ={};
                    callbackValue.activitiUsers = accountArray;
                    callbackValue.type = type;
                    callback(callbackValue);
                });
            };
            actText.getText = (data,type,callback) =>{
                if(data){
                    that.textareaModalTitle = data.title;
                }
                that.callbackType = type;
                that.callback = callback;
                that.setState({
                    textareaModalVisible : true
                });
            };
            //重写推进前保存方法
            activiti.afterSave = (activiti,call) => {
                that.onlySave(call)
            };
            activiti.endFunction = (activiti,call) =>{  //流程推进后的回调一般用作推进后修改状态
                saveStatusName({
                    weiboId: that.weiboId,
                    statusName: activiti.options.statusNameTemp
                },(data) =>{
                    if (data.code === 200) {
                        call({status: true, msg: data.msg});
                    } else {
                        call({status: false, msg: "流程推进后状态修改失败。"});
                    }
                });
            };
            activiti.submitOK = (activiti,call) => {     //流程推进成功后的提示点击确定的回调，一般用来关闭窗口或刷新
                that.refreshList();
            };

            activiti.successMsg = (layerMsg,call) => {
                let msg = typeof(layerMsg) === 'string' ? layerMsg : layerMsg.msg;
                message.success(msg,1,call);
            };

            activiti.error = (layerMsg,call) => {
                let msg = typeof(layerMsg) === 'string' ? layerMsg : layerMsg.msg;
                message.error(msg,1,call)
            };

            activiti.showRemarks = function(remarks){
                // 出现多次备注按钮问题，这里只是临时的解决方法
                if(remarks && $("#btnArea").find("#actRemarks").length === 0){
                    $("#btnArea").append('<img id="actRemarks" src="/cm-sites/images/fagao/instanceRecord.png" style="width: 25px;height:25px;margin-left: 10px; cursor: pointer" />');
                    $('#actRemarks').click(function () {
                        window.top.layer.alert(Activiti.util.escape(remarks));
                    })
                }
            }

            activiti.load.start = () =>{
                that.setState({loading : true})
            };

            activiti.load.end = () =>{
                that.setState({loading : false})
            }
            activiti.closeAll = () =>{
                that.setState({loading : false})
            };
        }
    },() => {});
};